/* SEARCH-TAG: page-template  */
import { graphql } from 'gatsby';
import Listing from './_Listing';

/**
 * `/blog/` and `/blog/2/` ... `/blog/N/` - created in gatsby-node.js.
 *
 * The `filter` below MUST stay in sync with `ARTICLE_FILTER` in
 * gatsby-node.js, which derives the page count from the same set.
 */
export const pageQuery = graphql`
    query BlogListing($limit: Int!, $skip: Int!) {
        pageContent: datoCmsBlogLandingPage {
            seoMetaTags {
                ...GatsbyDatoCmsSeoMetaTags
            }
            heroContent {
                ...textStructuredFields
            }
            latestArticleText
            searchPlaceholder
        }

        allArticles: allDatoCmsBlogArticle(
            filter: { noIndex: { ne: true } }
            sort: [{ date: DESC }, { slug: ASC }]
            limit: $limit
            skip: $skip
        ) {
            nodes {
                id
                title
                slug
                summary
                featuredImage {
                    gatsbyImageData(
                        width: 400
                        layout: CONSTRAINED
                        placeholder: NONE
                    )
                }
                categories {
                    name
                }
            }
        }
    }
`;

export default Listing;
